/** Cents → "$1,234.56". Unlike orderForm's fmtMoney, keeps the cents (these are
 * estimate line totals, so the decimals matter). */
export const formatCents = (cents: unknown): string => {
  const n = Number(cents);
  if (!Number.isFinite(n)) return '—';
  return (n / 100).toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/** Whole-percent (or one decimal) label, e.g. "12%" / "1.5%". */
export const formatPct = (n: number): string => `${Number.isInteger(n) ? n : n.toFixed(1)}%`;
